<template>
  <transition name="slide-y-transition" mode="out-in">
    <div class="table table_middle" v-if="items.length">
      <modal></modal>
      <table :class="{drag: drag}">
        <thead>
        <tr>
          <!--<icon-arrowup/>-->
          <th class="caption">Заголовок<span class="table_move"></span></th>
          <th class="middle little">Видимость</th>
          <th class="icons"></th>
        </tr>
        </thead>
        <draggable v-model="dragItems"
                   v-bind="dragOptions"
                   @start="drag = true"
                   @end="draggableEnd($event)"
                   tag="tbody">
          <tr v-for="(item, index) in items" v-bind:key="item.id" :data-id="index" class="list-group-item">
          <router-link :to="`/quotes/${item.id}/edit`" class="table-link caption link">
            <span>{{item.title}}</span>
          </router-link>
          <td class="middle little">
            <v-switch
              v-model="item.is_active" :color="'#089cd3'"
              @click.capture.stop="toggleActive(item)">
            </v-switch>
          </td>
          <td class="icons">
            <router-link :to="`/quotes/${item.id}/edit`" class="edit">
              <icon-pencil/>
              <div class="hint left edit">Редактировать</div>
            </router-link>
            <a class="delete-icon" @click.prevent="onDeleteItem(item)">
              <icon-delete/>
              <div class="hint left">Удалить</div>
            </a>
          </td>
        </tr>
        </draggable>
      </table>
    </div>
  </transition>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import IconDelete from '@/components/icons/IconDelete'
  import IconArrowup from '@/components/icons/IconArrowup'
  import IconPencil from '@/components/icons/IconPencil'
  import Modal from '@/components/Modal'

  const {mapActions, mapState, mapMutations} = createNamespacedHelpers('mainPage')

  export default {
    data () {
      return {
        drag: false
      }
    },
    computed: {
      faPencilAlt () {
        return faPencilAlt
      },
      faTrash () {
        return faTrash
      },
      faLink () {
        return faLink
      },
      apiDomain () {
        return this.$store.state.apiDomain
      },
      siteUrl () {
        return this.$store.state.siteUrl
      },
      parentId () {
        return this.$store.state.parentId
      },
      ...mapState([
        'items'
      ]),
      dragOptions () {
        return {
          animation: 200,
          group: 'description',
          disabled: false,
          ghostClass: 'ghost'
        }
      },
      dragItems: {
        get () {
          return this.items
        },
        set (value) {
          this.setItems(value)
        }
      }
    },
    methods: {
      ...mapActions([
        'getItems',
        'toggleItem',
        'onEditItem',
        'deleteItem',
        'setNewOrder'
      ]),
      ...mapMutations([
        'setShowModal',
        'setItems',
        'setItemForDelete'
      ]),
      toggleActive(item) {
          item.is_active = !item.is_active;
        this.toggleItem({
          title: item.title,
          isActive: item.is_active,
          id: item.id,
          section_id: this.parentId.quotes,
          url: {
            categoryId: null,
            articleUrl: item.url
          },
          img: item.img,
          subtext: item.seo_desc
        })
      },
      draggableEnd (e) {
        this.drag = false
        let item = this.items[e.item.getAttribute('data-id')]
        let index = item.ord
        console.log(e.newIndex, e.oldIndex)
        if (e.newIndex > e.oldIndex) {
          index -= (e.newIndex - e.oldIndex)
        } else {
          index += (e.oldIndex - e.newIndex)
        }
        console.log(index)
        this.setNewOrder({
          id: item.id,
          order: index
        })
      },
      onDeleteItem (item) {
        this.setItemForDelete({id: item.id, title: item.title, url: 'contents', img: item.img});
        this.setShowModal(true)
      }
    },
    components: {
      IconDelete,
      IconPencil,
      IconArrowup,
      Modal
    }
  }
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/quotes/MainTable.vue